import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

const ColumnTitleWithInfo = ({ title, info, zIndex = 4 }) => (
  <span
    className="d-flex align-center"
    style={{ gap: 6, whiteSpace: 'nowrap' }}
  >
    {title}
    {info ? (
      <Tooltip
        title={info}
        placement="top"
        zIndex={zIndex}
        trigger={['hover', 'focus']}
      >
        <InfoCircleOutlined
          className="pointer"
          tabIndex={0}
          aria-label={
            typeof title === 'string'
              ? `${title} information`
              : 'Column information'
          }
        />
      </Tooltip>
    ) : null}
  </span>
);

export default ColumnTitleWithInfo;
